import Main3TCWrapper from "../../components/live3/tc/Main3TCWrapper";
import { config3 } from "../../constant/initDrawing";


const config = {
    ...config3,
    type: "vnone",
    hlBG: "#F08D1D",
    row_0: "#bb1414a2",

}

const Live3MCPage = () => {
    return <Main3TCWrapper config={config} />
}

export default Live3MCPage;